// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1JHYR","rootSmall":"AddTileButton_rootSmall__2hQSM"};